import { Form } from "antd";
import type React from "react";
import type { MemberAttribute } from "../../../../../shared/types/member.types";
import { useMemberAttributeContext } from "../../../providers/MemberAttributeContext";
import { FilterWrapper } from "../FilterWrapper";
import { CustomDatePicker } from "../styles";
import type { MemberAttributeFilterConfig } from "../types";

export const RangedDateFilter: React.FC<{
	memberAttribute?: MemberAttribute;
	config?: MemberAttributeFilterConfig;
}> = (props) => {
	const memberAttributeContext = useMemberAttributeContext();
	const memberAttribute =
		props.memberAttribute || memberAttributeContext.memberAttribute;
	const config = props.config || memberAttributeContext.config;

	if (!memberAttribute.memberAttributeId) return null;
	const range = [
		{ value: "Min", label: "から" },
		{ value: "Max", label: "まで" },
	];

	if (config.layout === "vertical") {
		return (
			<FilterWrapper
				key={`${memberAttribute.label}${memberAttribute.memberAttributeId}`}
				config={config}
				itemKey={`${memberAttribute.label}${memberAttribute.memberAttributeId}`}
			>
				<Form.Item className="mb-0">
					{range.map((bound, index) => (
						<Form.Item
							help={`${memberAttribute.label}${bound.label}`}
							name={`memberAttributeFilter${memberAttribute.memberAttributeId}${bound.value}`}
							key={`${memberAttribute.memberAttributeId}${bound.value}_${index}`}
							className={`inline-block ${index !== range.length - 1 ? "mr-2" : ""} mb-4`}
							style={{ width: "calc(50% - 0.25rem)" }}
						>
							<CustomDatePicker className="w-full" inputReadOnly />
						</Form.Item>
					))}
				</Form.Item>
			</FilterWrapper>
		);
	}

	return (
		<>
			{range.map((bound, index) => (
				<FilterWrapper
					key={`${memberAttribute.label}${memberAttribute.memberAttributeId}_${index}`}
					config={config}
					itemKey={`${memberAttribute.label}${memberAttribute.memberAttributeId}_${index}`}
				>
					<Form.Item
						help={
							config.showHelpText
								? `${memberAttribute.label}${bound.label}`
								: undefined
						}
						name={`memberAttributeFilter${memberAttribute.memberAttributeId}${bound.value}`}
						className="mb-4 w-full"
					>
						<CustomDatePicker className="w-full" inputReadOnly />
					</Form.Item>
				</FilterWrapper>
			))}
		</>
	);
};
